import { render, staticRenderFns } from "./ClientTransactionView.vue?vue&type=template&id=31b75fd1"
import script from "./ClientTransactionView.vue?vue&type=script&lang=js"
export * from "./ClientTransactionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports